import type { InstaUser } from "@/insta/types/instaTypes";

export function exportCSV(users: InstaUser[], filename: string): void {
  const header = "username,profile_url,follow_date";
  const rows = users.map((u) => {
    const date = new Date(u.timestamp * 1000).toISOString().split("T")[0];
    return `${u.value},${u.href},${date}`;
  });
  const csv = [header, ...rows].join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

export async function copyUsernames(users: InstaUser[]): Promise<boolean> {
  const text = users.map((u) => u.value).join("\n");
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
